export enum EscapeHatchReason {
    VERIFF_ERROR = "VERIFF_ERROR",
    UI_ERROR = "UI_ERROR",
    CANCELED_VERIFF = "CANCELED_VERIFF",
    NO_ERROR = "NO_ERROR"
}


// WEBPACK FOOTER //
// ./src/constants/EscapeHatchReason.ts